export default class AppConfig {
    public static PowFormUrl: string = process.env.REACT_APP_POWFORM_URL!;
    public static MuiLicenceKey: string = process.env.REACT_APP_MUI_LICENCE_KEY!;
}
